var map = {
	"./Favorites": [
		1134,
		9,
		121
	],
	"./Favorites.tsx": [
		1134,
		9,
		121
	],
	"./FavoritesDeferred": [
		364,
		9
	],
	"./FavoritesDeferred.tsx": [
		364,
		9
	],
	"./FavoritesPage": [
		363,
		9
	],
	"./FavoritesPage.dictionary": [
		337,
		3
	],
	"./FavoritesPage.dictionary.json": [
		337,
		3
	],
	"./FavoritesPage.explanation": [
		1135,
		9,
		122
	],
	"./FavoritesPage.explanation.ts": [
		1135,
		9,
		122
	],
	"./FavoritesPage.tsx": [
		363,
		9
	],
	"./actions": [
		99,
		9
	],
	"./actions/": [
		99,
		9
	],
	"./actions/index": [
		99,
		9
	],
	"./actions/index.ts": [
		99,
		9
	],
	"./components/Loader": [
		1022,
		9,
		54
	],
	"./components/Loader/": [
		1022,
		9,
		54
	],
	"./components/Loader/Loader": [
		972,
		9,
		187
	],
	"./components/Loader/Loader.dictionary": [
		927,
		3,
		188
	],
	"./components/Loader/Loader.dictionary.json": [
		927,
		3,
		188
	],
	"./components/Loader/Loader.explanation": [
		1136,
		9,
		189
	],
	"./components/Loader/Loader.explanation.ts": [
		1136,
		9,
		189
	],
	"./components/Loader/Loader.module.scss": [
		1035,
		9,
		309
	],
	"./components/Loader/Loader.tsx": [
		972,
		9,
		187
	],
	"./components/Loader/index": [
		1022,
		9,
		54
	],
	"./components/Loader/index.ts": [
		1022,
		9,
		54
	],
	"./components/NoData": [
		1023,
		9,
		56
	],
	"./components/NoData/": [
		1023,
		9,
		56
	],
	"./components/NoData/NoData": [
		973,
		9,
		191
	],
	"./components/NoData/NoData.dictionary": [
		930,
		3,
		192
	],
	"./components/NoData/NoData.dictionary.json": [
		930,
		3,
		192
	],
	"./components/NoData/NoData.explanation": [
		1137,
		9,
		193
	],
	"./components/NoData/NoData.explanation.ts": [
		1137,
		9,
		193
	],
	"./components/NoData/NoData.module.scss": [
		1036,
		9,
		311
	],
	"./components/NoData/NoData.tsx": [
		973,
		9,
		191
	],
	"./components/NoData/index": [
		1023,
		9,
		56
	],
	"./components/NoData/index.ts": [
		1023,
		9,
		56
	],
	"./components/NoDataSkeleton": [
		895,
		9,
		57
	],
	"./components/NoDataSkeleton/": [
		895,
		9,
		57
	],
	"./components/NoDataSkeleton/NoDataSkeleton": [
		876,
		9,
		194
	],
	"./components/NoDataSkeleton/NoDataSkeleton.module.scss": [
		928,
		9,
		312
	],
	"./components/NoDataSkeleton/NoDataSkeleton.tsx": [
		876,
		9,
		194
	],
	"./components/NoDataSkeleton/constants": [
		896,
		9,
		195
	],
	"./components/NoDataSkeleton/constants.ts": [
		896,
		9,
		195
	],
	"./components/NoDataSkeleton/index": [
		895,
		9,
		57
	],
	"./components/NoDataSkeleton/index.ts": [
		895,
		9,
		57
	],
	"./components/PopularMatches": [
		897,
		9,
		59
	],
	"./components/PopularMatches/": [
		897,
		9,
		59
	],
	"./components/PopularMatches/PopularMatches": [
		877,
		9,
		200
	],
	"./components/PopularMatches/PopularMatches.dictionary": [
		879,
		3,
		201
	],
	"./components/PopularMatches/PopularMatches.dictionary.json": [
		879,
		3,
		201
	],
	"./components/PopularMatches/PopularMatches.explanation": [
		1138,
		9,
		202
	],
	"./components/PopularMatches/PopularMatches.explanation.ts": [
		1138,
		9,
		202
	],
	"./components/PopularMatches/PopularMatches.module.scss": [
		929,
		9,
		314
	],
	"./components/PopularMatches/PopularMatches.tsx": [
		877,
		9,
		200
	],
	"./components/PopularMatches/index": [
		897,
		9,
		59
	],
	"./components/PopularMatches/index.ts": [
		897,
		9,
		59
	],
	"./components/SportGrid": [
		863,
		9,
		67
	],
	"./components/SportGrid/": [
		863,
		9,
		67
	],
	"./components/SportGrid/SportGrid": [
		846,
		9,
		214
	],
	"./components/SportGrid/SportGrid.module.scss": [
		878,
		9,
		319
	],
	"./components/SportGrid/SportGrid.tsx": [
		846,
		9,
		214
	],
	"./components/SportGrid/index": [
		863,
		9,
		67
	],
	"./components/SportGrid/index.ts": [
		863,
		9,
		67
	],
	"./components/TournamentTable": [
		847,
		9,
		78
	],
	"./components/TournamentTable/": [
		847,
		9,
		78
	],
	"./components/TournamentTable/TournamentTable": [
		839,
		9,
		227
	],
	"./components/TournamentTable/TournamentTable.ts": [
		839,
		9,
		227
	],
	"./components/TournamentTable/index": [
		847,
		9,
		78
	],
	"./components/TournamentTable/index.ts": [
		847,
		9,
		78
	],
	"./reducer": [
		294,
		9
	],
	"./reducer/": [
		294,
		9
	],
	"./reducer/entities": [
		349,
		9
	],
	"./reducer/entities.ts": [
		349,
		9
	],
	"./reducer/index": [
		294,
		9
	],
	"./reducer/index.js": [
		294,
		9
	],
	"./reducer/presentation": [
		350,
		9
	],
	"./reducer/presentation.ts": [
		350,
		9
	],
	"./selectors/gridEntities": [
		128,
		9
	],
	"./selectors/gridEntities.ts": [
		128,
		9
	],
	"./selectors/gridPresentation": [
		1083,
		9,
		257
	],
	"./selectors/gridPresentation.ts": [
		1083,
		9,
		257
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1261;
module.exports = webpackAsyncContext;